

export function validationSchedule (val) {
  let showError = true;
  if (val && val.availability && val.from_time && val.to_time) {
    showError = false;
  }
  if (val && val.availability === 'rotative' && val.text !== '') {
    showError = false;
  }
  return showError ? 'error' : false;
}
